@if (user()?.subscription; as sub) {
  <div
    class="flex flex-col gap-y-2 rounded-md border border-neutral-a4 bg-neutral-a2 hover:bg-neutral-a3 hover:border-neutral-a6 px-3 py-2.5 w-full cursor-pointer transition-colors duration-200 select-none focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-primary-9"
    (click)="$event.stopPropagation(); navigateToSubscription()"
    (keydown.enter)="$event.stopPropagation(); navigateToSubscription()"
    (keydown.space)="$event.preventDefault(); $event.stopPropagation(); navigateToSubscription()"
    role="button"
    tabindex="0"
  >
    <div class="flex items-center justify-between gap-x-2">
      <span class="text-[10px] font-semibold uppercase tracking-wider text-neutral-10 leading-none">
        Abonnement
      </span>
      @if (planName(); as plan) {
        <span class="truncate text-xs font-semibold text-neutral-12 leading-none">
          {{ plan }}
        </span>
      }
    </div>

    <div class="flex items-center">
      <aura-subscription-status-chip [status]="sub.status" />
    </div>
  </div>
}
